import { toastsSlice } from "./slice";

export const { addToast, removeToast, removeBatch } = toastsSlice.actions;
